import React from 'react';
import { Box, Typography } from '@mui/material';

const EmptyState = ({ text = 'No hay información disponible.' }) => {
  return (
    <Box sx={{ py: 4, textAlign: 'center' }}>
      <Typography variant="body2" color="text.secondary">
        {text}
      </Typography>
    </Box>
  );
};

export default EmptyState;